<template>
    <performance-common-dialog
        :title="'明细装车页面'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="config.form"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="分公司名称：" prop="companyName">
                            <span>{{ componentsData.companyName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="平台名称：" prop="siteName">
                            <span>{{ componentsData.siteName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="发车单状态："
                            prop="dispatchStatusName"
                        >
                            <span>{{ componentsData.dispatchStatusName }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="发车单号：" prop="dispatchNo">
                            <span>{{ componentsData.dispatchNo }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="承运商名称：" prop="carrierName">
                            <span>{{ componentsData.carrierName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="实际车牌号：" prop="vehicleCard">
                            <span>{{ componentsData.vehicleCard }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item
                            label="实际车型名称："
                            prop="equipmentName"
                        >
                            <span>{{ componentsData.equipmentName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="司机名称：" prop="driver">
                            <span>{{ componentsData.driver }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="司机联系方式："
                            prop="driverContactWay"
                        >
                            <span>{{ componentsData.driverContactWay }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template #table-list>
            <!-- 表格 -->
            <dispatch-detailed-load-table
                :componentsData="componentsData"
            ></dispatch-detailed-load-table>
            <!-- 表格 -->
        </template>
    </performance-common-dialog>
</template>
<script>
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchDetailedLoadTable from './DispatchDetailedLoadTable';
import config from './config.js';

export default {
    name: 'dispatchDetailedLoading',
    components: { PerformanceCommonDialog, DispatchDetailedLoadTable },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            currentPage: 1,
            optionNum: 'SYS_WM_ASN_STATUS,SYS_WM_SO_STATUS'
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        }
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
</style>
